module.exports = __webpack_public_path__ + "img/Playmaker.de997bec.png";